module.exports = __webpack_public_path__ + "static/media/client-boredpass.5d3bc878.png";